/**
 * 콘텐츠 제출 링크 정규화 유틸 (SID-4170).
 *
 * 사용자가 `https://` 스킴을 붙이지 않고 `www.naver.com`, `naver.com` 처럼 입력해도
 * 허용해야 한다. 검증/아웃링크 시 절대 URL 이 필요하므로 스킴이 없으면 `https://` 를
 * 자동으로 붙인 정규화 결과를 도출한다. (사용자가 화면에 입력한 원문은 보존하고,
 * 제출·아웃링크 시점에만 정규화 결과를 사용한다.)
 */

/** 이미 스킴(`http://`, `https://`, 그 외 `scheme://`)이 붙어 있는지. */
const hasScheme = (value: string): boolean => /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(value);

/**
 * 입력값에 스킴이 없으면 `https://` 를 prepend 한다.
 * - 앞뒤 공백은 제거한다.
 * - 빈 문자열은 그대로 빈 문자열을 반환한다.
 * - 이미 스킴이 있으면 (http/https/기타) 그대로 둔다.
 */
export const normalizeContentUrl = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed === '') return '';
  if (hasScheme(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

/**
 * 콘텐츠 링크 입력이 유효한 형식인지 검증한다.
 *
 * 스킴 누락을 허용하기 위해 정규화 후 `URL` 파싱이 가능하고 host 에 점(.)을 포함한
 * (= 도메인 형태) 값인지로 판단한다. `http(s)` 외 스킴은 콘텐츠 링크로 부적합하므로 거른다.
 */
export const isValidContentUrl = (value: string): boolean => {
  const normalized = normalizeContentUrl(value);
  if (normalized === '') return false;
  try {
    const url = new URL(normalized);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    return url.hostname.includes('.');
  } catch {
    return false;
  }
};
